<template>
  <div id="container"></div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "map-view",
  mounted() {
    this.initAMap();
    // if (typeof window.AMap === 'function') {
    // 	this.initAMap()
    // } else {
    // 	const script = document.createElement('script')
    // 	window._AMapSecurityConfig = {securityJsCode:'a18666a7ab9100e99a35bdd550376440'}
    // 	// 动态引入较大类库避免影响页面展示10
    // 	script.src="https://webapi.amap.com/maps?v=2.0&key=5af5c5d67618c57333a6a17d5dcee4f4&plugin=AMap.Geolocation"
    // 	script.onload = this.initAMap()
    // 	document.head.appendChild(script)
    // 	console.log(script,"78747")
    // };
  },
  unmounted() {
    this.map?.destroy();
  },
  methods: {
    initAMap() {
      let _vm = this;
      window._AMapSecurityConfig = {
        securityJsCode: "a18666a7ab9100e99a35bdd550376440",
      };
      AMapLoader.load({
        key: "5af5c5d67618c57333a6a17d5dcee4f4", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          _vm.map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "3D", // 是否为3D地图模式
            zoom: 5, // 初始化地图级别
            center: [116.397428, 39.90923], // 初始化地图中心点位置
          });
          AMap.plugin("AMap.Geolocation", function () {
            var geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, //是否使用高精度定位，默认:true
              timeout: 10000, //超过10秒后停止定位，默认：无穷大
              maximumAge: 0, //定位结果缓存0毫秒，默认：0
              noIpLocate: 0,
              noGeoLocation: 0,
              GeoLocationFirst: true, //是否优先使用IP定位，默认：false
              convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
              showButton: true, //显示定位按钮，默认：true
              buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
              buttonOffset: new AMap.Pixel(50, 50), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
              showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
              panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            });
            _vm.map.addControl(geolocation);
            geolocation.getCurrentPosition(function (status, result) {
              if (status === "complete") {
                onComplete(result);
                return;
              }
              onError(result);
            });
          });
          //解析定位结果
          function onComplete(data) {
            regeoCode(data.position).then((res) => {
              // Config.value = res;
              // _vm.$message({
              //   message: "定位成功",
              //   type: "success",
              // });
              console.log(res, "res");
            });
          }
          //解析定位错误信息
          function onError(data) {
            // _vm.$message({
            //   message: data.message,
            //   type: "error",
            // });
            console.log(data, "data");
          }

          function regeoCode(top) {
            return new Promise((resolve) => {
              AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                  radius: 1000, //范围，默认：500
                });
                var lnglat = [top.lng, top.lat];
                geocoder.getAddress(lnglat, function (status, result) {
                  if (status === "complete" && result.regeocode) {
                    resolve(result.regeocode.formattedAddress);
                  }
                });
              });
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
#container {
  width: 100%;
  height: 800px;
}
</style>
